import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  const stats = [{
    value: t('about.stat1.value'),
    label: t('about.stat1.label')
  }, {
    value: t('about.stat2.value'),
    label: t('about.stat2.label')
  }, {
    value: t('about.stat3.value'),
    label: t('about.stat3.label')
  }];
  return <section className="relative py-20 md:py-28 bg-ink" data-id="element-15">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-17">
          <p className="text-gold text-xs tracking-[0.3em] mb-4" data-id="element-18">
            {t('about.eyebrow')}
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-cream mb-8 leading-[1.1]" data-id="element-19">
            {t('about.title.1')}{' '}
            <span className="italic gold-text" data-id="element-20">{t('about.title.2')}</span>
          </h2>

          {/* Decorative gold divider */}
          <div className="flex items-center justify-center gap-3 mb-8" aria-hidden data-id="element-21">
            <span className="h-px w-10 bg-gold/40" data-id="element-22" />
            <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-23" />
            <span className="h-px w-10 bg-gold/40" data-id="element-24" />
          </div>

          <p className="text-cream/75 text-base md:text-lg leading-relaxed mb-5" data-id="element-25">
            {t('about.p1')}
          </p>
          <p className="text-cream/60 text-base leading-relaxed mb-12" data-id="element-26">
            {t('about.p2')}
          </p>
        </motion.div>

        {/* Stats — uniform, equal-height, balanced */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="grid grid-cols-3 gap-3 md:gap-5 mb-10" data-id="element-27">
          {stats.map(s => <div key={s.label} className="border border-gold/20 rounded-sm p-4 md:p-6 flex flex-col items-center justify-center min-h-[120px] md:min-h-[140px] hover:border-gold/50 transition-colors" data-id="element-28">
              <div className="font-display text-2xl md:text-3xl gold-text mb-2 leading-none" data-id="element-29">
                {s.value}
              </div>
              <div className="text-[10px] md:text-xs text-cream/60 tracking-[0.15em] uppercase leading-tight text-balance" data-id="element-30">
                {s.label}
              </div>
            </div>)}
        </motion.div>

        <motion.a href="#contacto" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="group inline-flex items-center gap-2 text-gold hover:text-gold-light transition-colors text-sm tracking-wider" data-id="element-31">
          {t('hero.cta.primary')}
          <ArrowRightIcon size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-32" />
        </motion.a>
      </div>
    </section>;
}